<template>
  <div>
    <v-row justify="center">
      <v-dialog
        v-model="dialog2"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        scrollable
      >
        <v-card tile>
          <v-toolbar flat dark color="#00a65ad4">
            <v-btn icon dark @click="dialog2 = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Vérification</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items> </v-toolbar-items>
          </v-toolbar>

          <v-spacer >
            <v-card-title class="card-tile justify-center">
              Votre numéro de Téléphone:&nbsp;<strong color="#00a65ad4">
                {{ postdatafinal.coordinates.tel }}
              </strong>
              <a href="" @click.prevent="updatetelnum"
                >{{ text_update_tel }}
              </a>
            </v-card-title>
            <v-col cols="12" md="12" v-if="this.updating_tel_num">
              <v-text-field
                v-model="postdatafinal.coordinates.tel"
                solo
                label="Numéro de téléphone"
                required @blur="updatetelnum"
                :rules="rule_tel"
              ></v-text-field>
            </v-col>
          </v-spacer>

          <v-card-text >
            <v-card-title tile :color="colorgreen" class=" justify-center">
              Paiement  à la livraison
            </v-card-title>
            <v-card-actions class="">
              <v-row>
                <v-col xs="12" md="12">
                  <v-btn
                    xs4
                    color="#00a65ad4" v-if="showtoplaunch"
                    class="btn-launch"
                    @click.prevent="orderLaunched" :disabled="nolaunch"
                    >Lancer la commande</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-actions>
             <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="contentcoord"
                    >Vos coordonnées

                  </v-list-item-title>
                  <v-list-item-subtitle class="subtitlecoord"
                    >{{ postdatafinal.coordinates.firstname }}
                    {{
                      postdatafinal.coordinates.lastname
                    }}</v-list-item-subtitle
                  >
                  <v-list-item-subtitle class="subtitlecoord">{{
                    postdatafinal.coordinates.tel
                  }}</v-list-item-subtitle>
                  <v-list-item-subtitle class="subtitlecoord">{{
                    postdatafinal.coordinates.email
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content class="livraison-content">
                  <v-list-item-title class=" contentcoord"
                    >Livraison



                    <v-list-item v-if="postdatafinal.delivery.positionnable">
                        <v-list-item-content class="livraison-content">
                          <v-list-item-title v-if="postdatafinal.delivery.locationdetails.name_loc !== '' ">
                            POINT DE LIVRAISON: {{postdatafinal.delivery.locationdetails.name_loc}}
                          </v-list-item-title> <v-spacer></v-spacer>
                          <v-list-item-subtitle v-if="postdatafinal.delivery.locationdetails.complement_adress !== ''" >
                           COMPLEMENT D'ADRESSE:   {{postdatafinal.delivery.locationdetails.complement_adress}}
                          </v-list-item-subtitle>  <v-spacer style="margin-top:10px;margin-bottom:20px"></v-spacer>
                          <v-list-item-title v-if="postdatafinal.delivery.adress_indication !== '' ">
                           INDICATION: {{postdatafinal.delivery.adress_indication}}
                          </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                  </v-list-item-title>

                  <v-list-item-subtitle
                    class="ya latlng"
                    style="margin-bottom:12px"
                    >
                    <strong style="display:none">{{ postdatafinal.delivery.date_livraison }}</strong>
                    <p> <strong style="font-size:18px">Livraison:</strong>   La livraison débute le lendemain de la commande à <strong>16h</strong></p>
                  </v-list-item-subtitle>

                  <div
                    v-if="postdatafinal.delivery.positionnable"
                    class="padingtone"
                  >
                    <GmapMap
                      :center="postdatafinal.delivery.locationdetails.location"
                      :zoom="16"
                      map-type-id="terrain"
                      style="width: 100%; height: 400px; "
                    >
                      <GmapMarker
                        :position="postdatafinal.delivery.locationdetails.location"
                        :clickable="true"
                        :draggable="true"
                        @dragend="updateCoordinates"
                      />
                    </GmapMap>
                  </div>
                  <div v-if="!postdatafinal.delivery.positionnable"  >

    <v-alert dense border="left" type="danger" > {{text_message_geoloc}}</v-alert>
        <a href="" @click.prevent="localisationthen">Me localiser</a>
                  </div>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Articles</v-list-item-title>
                  <v-container fluid>
                    <v-layout
                      v-bind:key="elemkey"
                      row
                      v-for="(elemcart, elemkey) in postdatafinal.cart"
                    >
                      <v-flex xs2 order-md1 order-xs1>
                        <v-card white tile flat>
                          <v-card-text>{{ elemcart.quantity }}x</v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs5 order-md2 order-xs2>
                        <v-card white tile flat>
                          <v-card-text
                            >{{ elemcart.article.title }}&nbsp;x{{
                              elemcart.quantity
                            }}</v-card-text
                          >
                        </v-card>
                      </v-flex>
                      <v-flex xs5 order-md3 order-xs3>
                        <v-card white tile flat>
                          <v-card-text>{{ elemcart.total_price }}F</v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                    <v-divider class="mx-4"></v-divider>
                    <v-layout row>
                      <v-flex xs2 order-md1 order-xs1>
                        <v-card white tile flat>
                          <v-card-text></v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs5 order-md2 order-xs2>
                        <v-card white tile flat>
                          <v-card-text>Livraison </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs5 order-md3 order-xs3>
                        <v-card white tile flat>
                          <v-card-text
                            >{{
                              postdatafinal.delivery.price_livraison
                            }}F</v-card-text
                          >
                        </v-card>
                      </v-flex>
                    </v-layout>
                    <v-divider class="mx-4"></v-divider>
                    <v-layout row>
                      <v-flex xs2 order-md1 order-xs1>
                        <v-card white tile flat>
                          <v-card-text></v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs5 order-md2 order-xs2>
                        <v-card white tile flat>
                          <v-card-text>Total</v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs5 order-md3 order-xs3>
                        <v-card white tile flat>
                          <v-card-text>{{ getSum() }}F</v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-card-actions class="yangozend">
              <v-row>
                <v-col xs="12" md="12">
                  <v-btn
                    xs4
                    color="#00a65ad4"
                    class="btn-launch"
                    @click.prevent="orderLaunched" :disabled="nolaunch"
                    >Lancer la commande</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card-text>

          <div style="flex: 1 1 auto;"></div>


        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
export default {
  title: "FinalisationOrder",
  components: {},
  props: {
    postdatafinal: Object,
    idshop: String,
    redirect: String,
  },
  watch: {
    yaya: function() {}
  },

  data() {
    return {
      yaya: null,
      showtoplaunch:false,
      nolaunch:false,
      dialog2: false,
      payment_method: 1,
      notifications: false,
      sound: true,
      widgets: false,
      updating_tel_num: false,
      text_update_tel: "modifier",
      text_message_geoloc: 'Nous avons besoin de vos coordonnées GPS pour faciliter la livraison. Merci de cliquer sur me localiser',
      end_validation_process: false,
      test_subdomain: 'reinecabosse.ojay.delivery',
      end_message:'',
      items: [
        {
          title: "Click Me"
        },
        {
          title: "Click Me"
        },
        {
          title: "Click Me"
        },
        {
          title: "Click Me 2"
        }
      ],
      select: [
        { text: "State 1" },
        { text: "State 2" },
        { text: "State 3" },
        { text: "State 4" },
        { text: "State 5" },
        { text: "State 6" },
        { text: "State 7" }
      ],
      rule_tel: [
        v => !!v || "Ce champ est obligatoire, merci de le remplir",
        v => /^[0-9 \n\r\-\+\,\.\']*$/.test(v) || "Caractère non autorisé"
      ],
      colorgreen: "#00a65ad4",
      colorred: "#EF323D"
    };
  },

  watch: {},

  mounted() {
    console.log("<----- On est entrain de monter finalisation ---->");
    console.log("---------------*****end*****-------------");
    console.log(this.postdatafinal);
    this.dialog2 = true;
    console.log("end_________________________________end");
  },

  methods: {
    localisationthen(){
        this.getCurrentPosition();
    },
    extractSubdomain() {
       let subdomain = window.location.host;
      if (subdomain.includes("localhost")) {
         subdomain = this.test_subdomain;
      }
      subdomain = _.replace(subdomain, "www.", "");
      const parts = subdomain.split(".");
      return parts[0];
    },
    getCurrentPosition(){
        let Oldthis = this;
        this.$getLocation({
	          enableHighAccuracy: true
        })
          .then(coordinates => {

              console.log('trouver la position dat ')

              this.postdatafinal.delivery.positionnable=true;

              this.postdatafinal.delivery.position.lat = coordinates.lat
              this.postdatafinal.delivery.position.lng = coordinates.lng

          })
          .catch( (error) => {
                alert("Merci d'autorisier la géolocalisation au niveau de votre navigateur")
            });
      },
    updatetelnum() {
      this.updating_tel_num = !this.updating_tel_num;
      if (this.updating_tel_num) {
        this.text_update_tel = "Cacher";
      } else {
        this.text_update_tel = "Modifier";
      }
    },
    moveDialog() {
      this.dialog2 = !this.dialog2;
    },
    getSum() {
      let somsome = 0;
      somsome += parseInt(this.postdatafinal.delivery.price_livraison);
      console.log(
        "getSum price_ldivraison dans finalisation",
        parseInt(this.postdatafinal.delivery.price_livraison)
      );
      _.forEach(this.postdatafinal.cart, function(value, key) {
        somsome += parseInt(value.total_price);
      });
      return somsome;
    },
    postOrder(){

      //let redirect = 'https://douxgup.ojay.delivery/test';
      //this.redirect = "https://kiosk.ojay.delivery/test";
      let path_order = this.redirect+"/post/new/order";
      let Oldthis = this;
      console.log('ORDER TO POST ------ ===>',Oldthis.postdatafinal)
     this.$http.post(path_order, {'order':{
        'shop': Oldthis.idshop,
        'order':Oldthis.postdatafinal,
        'subdomain' : Oldthis.extractSubdomain()
      }} ).then(
      function (response) {
         console.log('postReservation',response.data)

      } ,function (response) {
          console.log("Nous avons bien une error");
          console.log('---------------------------');
          console.log(response)
     });
    },
    postSmsOrder(){
      let path_sms = "https://mojay.pro/sendsms.php";
      //"http://46.101.9.153/sos/sms/new"
      console.log('this http',this.$http)
      this.$http.post(path_sms, {
        'to': '781528375',
        'message': 'Votre est en cours de traitement '
      } ).then(
      function (response) {
         console.log('postReservation',response.data)

      } ,function (response) {
          console.log("Nous avons bien une error");
          console.log('---------------------------');
          console.log(response)
     });
    },
    orderLaunched() {
      this.dialog2 = false;
      //this.postSmsOrder();
      this.postOrder();
      this.end_message =
        "Votre commande à bien été enregistré. vous allez être livré demain Les horaires de livraison sont 12h et 17h merci";
      console.log('on lance la commade end_validation_process ===>',this.end_validation_process)
      this.$emit("welaunchorder", this.postdatafinal);
    },
    updateCoordinates(location) {
      this.postdatafinal.delivery.locationdetails.location = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng()
      };
    }
  }
};
</script>
<style>
.contentcoord {
  margin-bottom: 10px !important;
}
.subtitlecoord {
  list-style-type: disc;
  margin-left: 30px !important;
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}
.padingtone {
  margin: 0px 5px 0px 5px;
}
.latlng {
  margin-top: 5px;
  margin-bottom: 15px;
  font-weight: normal !important;
}

.indication {
  word-wrap: break-word !important;
}

.livraison-content > .ya {
  margin-left: 12px;
}

.ya {
  margin-top: 8px;
  margin-bottom: 8px;
}

.card-tile > a {
  font-size: 12px;
  margin-left: 12px;
}

.btn-launch {
  border: 0;
  color: #fff !important;
  width: 100%;
  margin-bottom: 25px;
  padding-top: 17px !important;
  padding-bottom: 17px !important;
}
.yangozend {
  padding-bottom: 300px;
}
.v-messages__message {
  color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pieces/finalisationorder.vue